import { lang } from '@ott/l10n';

// letter & numeric code | Germany = DE = 80
const westEuropeCountriesCodes = ['DE', 80, 'FR', 87, 'PL', 51, 'CZ', 54, 'AT', 81];
const finlandCountryCodes = ['FI', 10];

export default function getCountryChildrenAges(fromCode, toCode) {
  const checkStations = countryCodes =>
    countryCodes.includes(fromCode) || countryCodes.includes(toCode);

  switch (true) {
    case checkStations(westEuropeCountriesCodes):
      return {
        childAge: 12,
        infantAge: 4,
        babyAge: 1,
        defaultDocumentType: 'FOREIGN_PASSPORT',
      };
    case checkStations(finlandCountryCodes):
      return {
        childAge: 17,
        infantAge: 6,
        babyAge: 1,
        defaultDocumentType: 'FOREIGN_PASSPORT',
      };
    case lang === 'ru-kz':
      return {
        childAge: 15,
        infantAge: 7,
        babyAge: 1,
        defaultDocumentType: 'BIRTH_CERTIFICATE_KZ',
      };
    case lang === 'ru':
      return {
        childAge: 10,
        infantAge: 5,
        babyAge: 1,
        defaultDocumentType: 'BIRTH_CERTIFICATE',
      };
    default:
      return {
        childAge: 10,
        infantAge: 5,
        babyAge: 1,
        defaultDocumentType: null,
      };
  }
}
